module.exports = __webpack_public_path__ + "assets/icons/check-decagram-2157.svg";